export default __webpack_public_path__ + "static/media/Farmapremium .ef9a45cc.svg";